import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
  handlers: { [key: string]: DetachedRouteHandle } = {};
  private disableReuse = false;
  private authInitialized = false;

  constructor(private injector: Injector) {}

  private ensureAuthInitialized(): void {
    if (this.authInitialized) return;
    this.authInitialized = true;
    try {
      const auth = this.injector.get(AuthService);
      this.disableReuse = !auth.isAuthenticated();
      auth.isAuthenticated$.subscribe(() => {
        this.disableReuse = !auth.isAuthenticated();
        this.clearHandles();
      });
    } catch {
      this.disableReuse = true;
    }
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    //Сохраняем состояние только если reuse === true и пользователь залогинен
    this.ensureAuthInitialized();
    return !this.disableReuse && route.data && !!route.data['reuse'];
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.ensureAuthInitialized();
    if (!this.disableReuse && route.data && !!route.data['reuse']) {
      const key = this.getRouteKey(route);
      this.handlers[key] = handle;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    this.ensureAuthInitialized();
    const key = this.getRouteKey(route);
    // Восстанавливаем компонент если reuse === true, пользователь залогинен и есть сохраненный хендл
    return !this.disableReuse && !!route.data && !!route.data['reuse'] && !!this.handlers[key];
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    this.ensureAuthInitialized();
    if (this.disableReuse || !route.data || !route.data['reuse']) return null;
    const key = this.getRouteKey(route);
    return this.handlers[key] || null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return (
      future.routeConfig === curr.routeConfig &&
      JSON.stringify(future.params) === JSON.stringify(curr.params)
    );
  }

  private getRouteKey(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot.map((r) => r.url.map((segment) => segment.path).join('/')).join('_');
  }

  private clearHandles() {
    this.handlers = {};
  }
}
